import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DonationPaymentForm from './DonationPaymentForm';

export default function DonationPaymentStep({
  stripePublishableKey,
  stripeConnectedAccountId,
  clientSecret,
  onSuccess,
  buttonClassName = '',
  submitLabel = 'Donate',
  refreshKey = 0,
  onSubmittingChange = () => {},
  submitDisabled = false,
  renderSubmit = null,
}) {
  const stripePromise = useMemo(
    () =>
      loadStripe(
        stripePublishableKey,
        stripeConnectedAccountId ? { stripeAccount: stripeConnectedAccountId } : undefined
      ),
    [stripePublishableKey, stripeConnectedAccountId]
  );

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <DonationPaymentForm
        onSuccess={onSuccess}
        returnUrl={window.location.href}
        buttonClassName={buttonClassName}
        submitLabel={submitLabel}
        refreshKey={refreshKey}
        onSubmittingChange={onSubmittingChange}
        submitDisabled={submitDisabled}
        renderSubmit={renderSubmit}
      />
    </Elements>
  );
}

DonationPaymentStep.propTypes = {
  stripePublishableKey: PropTypes.string.isRequired,
  stripeConnectedAccountId: PropTypes.string,
  clientSecret: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  buttonClassName: PropTypes.string,
  submitLabel: PropTypes.string,
  refreshKey: PropTypes.number,
  onSubmittingChange: PropTypes.func,
  renderSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
};
